import React from 'react';
import { PropTypes } from 'prop-types';
import { CloseToastIcon } from '../Icons/Icons';
import tailwindTheme from '../../../../../config/tailwind.config';
import Icon from '../Icons/Icon';

const Toast = ({
  message, type = 'error', isSpinner = false, onClose,
}) => {
  const typeColors = {
    success: { bgColor: 'bg-vamos-success', textColor: 'text-vamos-white', iconColor: tailwindTheme.theme.extend.colors['vamos-white'] },
    error: { bgColor: 'bg-vamos-error', textColor: 'text-vamos-white', iconColor: tailwindTheme.theme.extend.colors['vamos-white'] },
    warning: { bgColor: 'bg-vamos-warning', textColor: 'text-vamos-white', iconColor: tailwindTheme.theme.extend.colors['vamos-white'] },
    info: { bgColor: 'bg-vamos-info', textColor: 'text-vamos-white', iconColor: tailwindTheme.theme.extend.colors['vamos-white'] },
    neutral: { bgColor: 'bg-vamos-neutral', textColor: 'text-vamos-black', iconColor: tailwindTheme.theme.extend.colors['vamos-black'] },
  };
  return (
    <div className={`flex py-2.5 px-4 gap-4 rounded-md items-center justify-center ${typeColors[type].bgColor}`}>
      <div className={`flex text-lg gap-x-4 font-medium ${typeColors[type].textColor}`}>
        {message}
        {isSpinner && (
        <Icon name="spinner" className="animate-spin" />
        )}
      </div>
      <button
        type="button"
        onClick={onClose}
        aria-label="Close"
      >
        <CloseToastIcon color={typeColors[type].iconColor} />
      </button>
    </div>
  );
};

Toast.propTypes = {
  message: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array]).isRequired,
  type: PropTypes.oneOf(['success', 'error', 'warning', 'info', 'neutral']),
  isSpinner: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
};

export default Toast;
